import { FC } from "react";

import { MapRouteBlockTypeEnum } from "@ryde/shared";

import { KanbanMap } from "../../common";
import { RidesCalendarMapStyled } from "./rides-calendar.styled";

export const RidesCalendarMap: FC = () => {
  return (
    <RidesCalendarMapStyled data-e2e="rides-calendar-map">
      <div className="rc-map__scroll">
        <KanbanMap routeBlockType={MapRouteBlockTypeEnum.Calendar} />
      </div>
    </RidesCalendarMapStyled>
  );
};
